import { useState, useEffect } from "react";
import { rootUrl } from "../common";

export const useResponsiveImage = (mediaId: string, mobileMediaId?: string) => {
  const [imageUrl, setImageUrl] = useState<string>("");
  const screenWidth = window.innerWidth;

  useEffect(() => {
    const getResponsiveSize = () => {
      // Define breakpoints and corresponding image sizes
      if (screenWidth >= 1250) {
        return 1250; // desktop
      } else if (screenWidth >= 900) {
        return 900; // ipad
      } else {
        return 500; // mobile
      }
    };

    const getMediaId = () => {
      if (screenWidth >= 768) {
        return mediaId;
      } else {
        return mobileMediaId || mediaId;
      }
    };

    const updateImageUrl = () => {
      const size = getResponsiveSize();
      setImageUrl(`${rootUrl}media/${getMediaId()}/${size}`);
    };

    // Set initial image URL
    updateImageUrl();

    // Add resize listener
    const handleResize = () => {
      updateImageUrl();
    };

    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [mediaId, mobileMediaId]);

  return imageUrl;
};
